import { Space } from "antd";

import "./EventDisplay.css";

const EventDisplay = ({ icon, title, info, date, actions }) => {
  return (
    <div className="carisity-event-row">
      <div className="carisity-event-col carisity-event-row-date">{date}</div>
      <div className="carisity-event-col carisity-event-row-icon">{icon}</div>
      <div className="carisity-event-col carisity-event-row-title">{title}</div>
      <div className="carisity-event-col carisity-event-row-info">{info}</div>
      <div className="carisity-event-col carisity-event-row-actions">
        <Space style={{ width: "100%" }}>{actions}</Space>
      </div>
    </div>
  );
};

export default EventDisplay;
